import { PERFORMANCE_DASHBOARD_DETAILS_REQUEST,
        PERFORMANCE_DASHBOARD_DETAILS_SUCCESS,
        PERFORMANCE_DASHBOARD_DETAILS_ERROR,

        SET_GPU_RAM_MEMORY_USAGE_REQUEST,
        SET_GPU_RAM_MEMORY_USAGE_SUCCESS,
        SET_GPU_RAM_MEMORY_USAGE_ERROR,
        SET_GPU_RAM_MEMORY_USAGE_RESET,

        SET_GPU_AVAILABLE_RAM_MEMORY_REQUEST,
        SET_GPU_AVAILABLE_RAM_MEMORY_SUCCESS,
        SET_GPU_AVAILABLE_RAM_MEMORY_ERROR,
        SET_GPU_AVAILABLE_RAM_MEMORY_RESET,

        SET_CPU_UTILIZATION_REQUEST,
        SET_CPU_UTILIZATION_SUCCESS,
        SET_CPU_UTILIZATION_ERROR,
        SET_CPU_UTILIZATION_RESET,

        SET_CPU_AVAILABLE_RAM_MEMORY_REQUEST,
        SET_CPU_AVAILABLE_RAM_MEMORY_SUCCESS,
        SET_CPU_AVAILABLE_RAM_MEMORY_ERROR,
        SET_CPU_AVAILABLE_RAM_MEMORY_RESET,


        // SET_CPU_RAM_MEMORY_USAGE_ERROR,
        // SET_CPU_RAM_MEMORY_USAGE_RESET,
        SET_CPU_RAM_MEMORY_USAGE_REQUEST,
        SET_CPU_RAM_MEMORY_USAGE_SUCCESS } from './../../../constants/closeLoop/performanceDashboard/performanceDashboardConstants';

const INITIAL_STATE = {
    gpuUtilization: {
        loading: false,
        error: '',
        xAxis: [],
        yAxis: []
    }
};

export const fetchPerformanceDashboardDetails = (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case PERFORMANCE_DASHBOARD_DETAILS_REQUEST:
            return {
                gpuUtilization: {
                    ...state.gpuUtilization,
                    loading: true,
                    error: '',
                    xAxis: [],
                    yAxis: []
                }
            }

        case PERFORMANCE_DASHBOARD_DETAILS_SUCCESS:
            return {
                gpuUtilization: {
                    ...state.gpuUtilization,
                    loading: false,
                    error: '',
                    xAxis: action.payload['GPU_utilization']['x-axis'],
                    yAxis: action.payload['GPU_utilization']['y-axis']
                }
            }

        case PERFORMANCE_DASHBOARD_DETAILS_ERROR:
            return {
                gpuUtilization: {
                    loading: false,
                    error: action.payload,
                    xAxis: [],
                    yAxis: []
                }
            }

        default:
            return state
    }
}


const GPU_RAM_MEMORY_USAGE_INITIAL_STATE = {
    gpuRAMMemoryUsage: {
        loading: false,
        error: '',
        xAxis: [],
        yAxis: []
    }
}

export const fetchGPURAMMemoryUsage = (state=GPU_RAM_MEMORY_USAGE_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_GPU_RAM_MEMORY_USAGE_REQUEST:
            return {
                gpuRAMMemoryUsage: {
                    ...state.gpuRAMMemoryUsage,
                    loading: true,
                    error: '',
                    xAxis: [],
                    yAxis: []
                }
            }

        case SET_GPU_RAM_MEMORY_USAGE_SUCCESS:
            return {
                gpuRAMMemoryUsage: {
                    ...state.gpuRAMMemoryUsage,
                    loading: false,
                    error: '',
                    xAxis: action.payload['GPU_RAM_memory_usage']['x-axis'],
                    yAxis: action.payload['GPU_RAM_memory_usage']['y-axis']
                }
            }

        case SET_GPU_RAM_MEMORY_USAGE_ERROR:
            return {
                gpuRAMMemoryUsage: {
                    ...state.gpuRAMMemoryUsage,
                    loading: false,
                    error: action.payload,
                    xAxis: [],
                    yAxis: []
                }
            }

        case SET_GPU_RAM_MEMORY_USAGE_RESET:
            return {
                gpuRAMMemoryUsage: {
                    ...state.gpuRAMMemoryUsage,
                    loading: false,
                    error: '',
                    xAxis: [],
                    yAxis: []
                }
            }

        default:
            return state
    }
}

const GPU_AVAILABLE_RAM_MEMORY_INITIAL_STATE = {
    gpuAvailableRAMMemory: {
        loading: false,
        error: '',
        xAxis: [],
        yAxis: []
    }
};


export const fetchGPUAvailableRAMMemory = (state=GPU_AVAILABLE_RAM_MEMORY_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_GPU_AVAILABLE_RAM_MEMORY_REQUEST:
            return {
                gpuAvailableRAMMemory: {
                    ...state.gpuAvailableRAMMemory,
                    loading: true,
                    error: ''
                }
            }

        case SET_GPU_AVAILABLE_RAM_MEMORY_SUCCESS:
            return {
                gpuAvailableRAMMemory: {
                    ...state.gpuAvailableRAMMemory,
                    loading: false,
                    error: '',
                    xAxis: action.payload['GPU_Available_RAM_memory']['x-axis'],
                    yAxis: action.payload['GPU_Available_RAM_memory']['y-axis']
                }
            }

        case SET_GPU_AVAILABLE_RAM_MEMORY_ERROR:
            return {
                gpuAvailableRAMMemory: {
                    ...state.gpuAvailableRAMMemory,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_GPU_AVAILABLE_RAM_MEMORY_RESET:
            return {
                gpuAvailableRAMMemory: {
                    ...state.gpuAvailableRAMMemory,
                    loading: false,
                    error: '',
                    xAxis: [],
                    yAxis: []
                }
            }

        default:
            return state
    }
};


const CPU_UTILIZATION_INITIAL_STATE = {
    cpuUtilization: {
        loading: false,
        error: '',
        xAxis: [],
        yAxis: []
    }
};

export const fetchCPUUtilization = (state=CPU_UTILIZATION_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_CPU_UTILIZATION_REQUEST:
            return {
                cpuUtilization: {
                    ...state.cpuUtilization,
                    loading: true,
                    error: ''
                }
            }

        case SET_CPU_UTILIZATION_SUCCESS:
            return {
                cpuUtilization: {
                    ...state.cpuUtilization,
                    loading: false,
                    error: '',
                    xAxis: action.payload['CPU_utilization']['x-axis'],
                    yAxis: action.payload['CPU_utilization']['y-axis']
                }
            }

        case SET_CPU_UTILIZATION_ERROR:
            return {
                cpuUtilization: {
                    ...state.cpuUtilization,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_CPU_UTILIZATION_RESET:
            return {
                cpuUtilization: {
                    ...state.cpuUtilization,
                    loading: false,
                    error: '',
                    xAxis: [],
                    yAxis: []
                }
            }

        default:
            return state
    }
};

const CPU_AVAILABLE_RAM_MEMORY_INITIAL_STATE = {
    cpuAvailableRAMMemory: {
        loading: false,
        error: '',
        xAxis: [],
        yAxis: []
    }
};


export const fetchCPUAvailableRAMMemory = (state=CPU_AVAILABLE_RAM_MEMORY_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_CPU_AVAILABLE_RAM_MEMORY_REQUEST:
            return {
                cpuAvailableRAMMemory: {
                    ...state.cpuAvailableRAMMemory,
                    loading: true,
                    error: '',
                    xAxis: [],
                    yAxis: []
                }
            }

        case SET_CPU_AVAILABLE_RAM_MEMORY_SUCCESS:
            return {
                cpuAvailableRAMMemory: {
                    ...state.cpuAvailableRAMMemory,
                    loading: false,
                    error: '',
                    xAxis: action.payload['Available_RAM_memory']['x-axis'],
                    yAxis: action.payload['Available_RAM_memory']['y-axis']
                }
            }

        case SET_CPU_AVAILABLE_RAM_MEMORY_ERROR:
            return {
                cpuAvailableRAMMemory: {
                    ...state.cpuAvailableRAMMemory,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_CPU_AVAILABLE_RAM_MEMORY_RESET:
            return {
                cpuAvailableRAMMemory: {
                    ...state.cpuAvailableRAMMemory,
                    loading: false,
                    error: '',
                    xAxis: [],
                    yAxis: []
                }
            }

        default:
            return state;
    }
};


const CPU_RAM_MEMORY_USAGE_INITIAL_STATE = {
    cpuRAMMemoryUsage: {
        loading: false,
        error: '',
        xAxis: [],
        yAxis: []
    }
};


export const fetchCPURAMMemoryUsage = (state=CPU_RAM_MEMORY_USAGE_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_CPU_RAM_MEMORY_USAGE_REQUEST:
            return {
                cpuRAMMemoryUsage: {
                    ...state.cpuRAMMemoryUsage,
                    loading: true,
                    error: ''
                }
            }

        case SET_CPU_RAM_MEMORY_USAGE_SUCCESS:
            return {
                cpuRAMMemoryUsage: {
                    ...state.cpuRAMMemoryUsage,
                    loading: false,
                    error: '',
                    xAxis: action.payload['RAM_memory_usage']['x-axis'],
                    yAxis: action.payload['RAM_memory_usage']['y-axis']
                }
            }

        default:
            return state;
    }
};